import React, { FunctionComponent } from 'react';

type Props = {
  isPage?: string;
  isReleasedRecruitmentsNone: boolean;
  q: string;
  targetEmploymentTypes: any;
  targetOccupations: any;
  targetOccupationDetails: any;
  targetPrefectureDetails: any;
  handleChangeQ: (event: any) => void;
  handleSearch: () => void;
  handleOpenSp: () => void;
  handleModal?: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isPage,
  isReleasedRecruitmentsNone,
  q,
  targetEmploymentTypes,
  targetOccupations,
  targetOccupationDetails,
  targetPrefectureDetails,
  handleChangeQ,
  handleOpenSp,
  handleSearch,
  handleModal,
}) => {
  const targetOccupationCount = (targetOccupations?.length || 0) + (targetOccupationDetails?.length || 0);
  return (
    <div className={`search-form__sp--search ${isPage === 'recruitments' && 'bgw'}`}>
      {isPage !== 'recruitments' && (
        <div className="search-form__sp--search--inner">
          <label>
            <input
              value={q}
              placeholder="27卒 古着"
              type="text"
              name="q"
              className="notbeforeunload"
              aria-label="27卒 古着"
              onChange={handleChangeQ}
              onBlur={handleSearch}
              enterKeyHint="search"
              onKeyDown={(event) => {
                if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
                  event.preventDefault();
                  event.currentTarget.blur();
                }
              }}
            />
            {/* <span className="search-form__inner__section--box--icon" onClick={handleSearch}></span> */}
          </label>
        </div>
      )}
      <div className="search-form__sp--search--list">
        <div
          className={`search-form__sp--search--list--item ${isReleasedRecruitmentsNone && 'disabled'}`}
          onClick={handleModal || handleOpenSp}
        >
          雇用形態
          {targetEmploymentTypes.length > 0 && <span>{targetEmploymentTypes.length}</span>}
          {targetEmploymentTypes.length === 0 && <p></p>}
        </div>
        <div
          className={`search-form__sp--search--list--item ${isReleasedRecruitmentsNone && 'disabled'}`}
          onClick={handleModal || handleOpenSp}
        >
          職種
          {targetOccupationCount > 0 && <span>{targetOccupationCount}</span>}
          {targetOccupationCount === 0 && <p></p>}
        </div>
        <div
          className={`search-form__sp--search--list--item ${isReleasedRecruitmentsNone && 'disabled'}`}
          onClick={handleModal || handleOpenSp}
        >
          勤務地
          {targetPrefectureDetails.length > 0 && <span>{targetPrefectureDetails.length}</span>}
          {targetPrefectureDetails.length === 0 && <p></p>}
        </div>
      </div>
    </div>
  );
};
